import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { darken, lighten } from '@/(routers)/boards/editor/block/blockTheme';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';

const COLOR_ON = lighten(CATEGORIES.operator.color);
const COLOR_OFF = darken(CATEGORIES.operator.color);

const ON_OFF_OPTIONS = [
    { value: '1', label: 'ON', tooltip: 'デジタル出力LOW [1 / true]' },
    { value: '0', label: 'OFF', tooltip: 'デジタル出力HIGH [0 / false]' },
];

defineBlock({
    type: 'on_off',
    colour: CATEGORIES.operator.color,
    tooltip: 'ONまたはOFFの値',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'VALUE',
                    instance: () => {
                        const field = new FieldOperatorDropdown(ON_OFF_OPTIONS);
                        field.setRectColour(COLOR_OFF);
                        field.setOnValueChange((value: string) => {
                            field.setRectColour(value === '1' ? COLOR_ON : COLOR_OFF);
                        });
                        return field;
                    },
                },
            ],
        },
    ],
    onInit(this: Blockly.Block) {},
});
